export const translations = {
  en: {
    nav: {
      products: "Products",
      enquiry: "Enquiry",
      contact: "Contact",
      cta: "Download Spec Sheet",
      est: "Pvt. Ltd. — Est. India",
    },
    mini: {
      heroEyebrow: "Aaravya Impex Private Limited — Chhatarpur, New Delhi",
      heroTitleA: "Gurjan, Eucalyptus & Okoumé.",
      heroTitleB: "Veneers, direct imported.",
      heroSub: "Premium gurjan face veneer and eucalyptus / okoumé core veneers for plywood, doors and furniture — straight from Myanmar, SE Asia and African mills to your factory.",
      viewProducts: "View Products",
      whatsapp: "WhatsApp Us",
      contactEyebrow: "Contact",
      contactTitle: "Talk to us",
    },
    products: {
      eyebrow: "Our Products",
      title: "Three veneers. One standard.",
      enquire: "Enquire",
      labels: { thickness: "Thickness", sizes: "Sizes", type: "Grade / Type", use: "Best for" },
      items: [
        { id: "gurjan", name: "Gurjan Face Veneer", tag: "The premium face for plywood & doors", thickness: "0.35 / 0.45 / 0.55 / 0.60 mm", sizes: "8×4 ft · 7×4 ft", type: "Grades A · B · C · D", use: "Decorative face — plywood, doors, panels" },
        { id: "eucalyptus", name: "Eucalyptus Core Veneer", tag: "Strong, uniform plantation core", thickness: "1.5 / 1.7 / 1.8 / 2.2 mm", sizes: "8×4 ft", type: "Plantation core grade", use: "Core layers — plywood & blockboard" },
        { id: "okume", name: "Okoumé Core Veneer", tag: "Lightweight African core, smooth finish", thickness: "1.5 – 2.5 mm", sizes: "8×4 ft", type: "Imported core (Gabon)", use: "Lightweight plywood, flush doors, panels" },
      ],
    },
    reg: {
      eyebrow: "Registered Office & Compliance",
      title: "Aaravya Impex Private Limited",
      motto: "Quality · Trust · Growth",
      addressLabel: "Registered Address",
      address: "C-50, Rajpur Khurd Extension, Chhatarpur, New Delhi – 110068",
      items: [
        { k: "GSTIN", v: "07ABFCA0324G1Z6" },
        { k: "PAN", v: "ABFCA0324G" },
        { k: "IEC", v: "ABFCA0324G" },
        { k: "UDYAM", v: "UDYAM-DL-08-0120430" },
        { k: "CIN", v: "U16211DL2026PTC464017" },
      ],
    },
    form: {
      eyebrow: "Send Requirements",
      titleA: "Tell us what you",
      titleItalic: "need.",
      intro: "Product, thickness, quantity — send your requirement and we reply with current stock and a landed quote within one working day.",
      name: "Your name *",
      company: "Company / firm",
      phone: "Phone / WhatsApp *",
      email: "Email",
      product: "Product",
      productOptions: ["Gurjan Face Veneer", "Eucalyptus Core Veneer", "Okoumé Core Veneer"],
      grade: "Grade required",
      thickness: "Thickness",
      quantity: "Monthly quantity (sheets)",
      message: "Message — delivery city, timeline, anything else",
      submit: "Send Enquiry",
      submitting: "Sending…",
      notSure: "Not sure — advise me",
      success: "Enquiry sent — we reply within one working day",
      error: "Could not send right now. Please use WhatsApp or email instead.",
      required: "Please fill name and phone",
      gradeOptions: ["Grade A — Sovereign", "Grade B — Premier", "Grade C — Merchant", "Grade D — Coreline"],
      thicknessOptions: ["0.35 mm", "0.45 mm", "0.55 mm", "0.60 mm"],
    },
    contact: {
      eyebrow: "Enquiries",
      titleA: "Let's talk",
      titleItalic: "timber.",
      body: "Mills, plywood houses, furniture manufacturers and traders — for current lots, landed pricing and spec sheets, write directly to our principal.",
      principalLabel: "Principal Contact",
      person: "Uma Shanker",
      phoneLabel: "Phone / WhatsApp",
      corridorsLabel: "Trade Corridors",
      corridorsValue: "C-50, Rajpur Khurd Extension, Chhatarpur, New Delhi – 110068",
      responseLabel: "Response Time",
      responseValue: "Enquiries answered within one working day",
      cardLabel: "Direct Line",
      cardText: "Mention your required grade, caliber and monthly off-take — we reply with current stock and a landed quote.",
      mailto: "Write to Uma Shanker",
      copy: "Copy Email Address",
      copied: "Copied",
      toastSuccess: "Email address copied",
      toastError: "Could not copy — please select the address manually",
    },
    footer: {
      tagline: "Gurjan · Eucalyptus · Okoumé Veneer — Direct Import",
      rights: "Aaravya Impex Private Limited",
      links: { products: "Products", enquiry: "Enquiry", contact: "Contact" },
    },
    whatsapp: {
      label: "Chat on WhatsApp",
      message: "Hello Aaravya Impex, I would like to enquire about veneer.",
    },
  },

  hi: {
    nav: {
      products: "प्रोडक्ट",
      enquiry: "पूछताछ",
      contact: "संपर्क",
      cta: "स्पेक शीट डाउनलोड करें",
      est: "प्रा. लि. — भारत",
    },
    mini: {
      heroEyebrow: "आरव्य इम्पेक्स प्राइवेट लिमिटेड — छत्तरपुर, नई दिल्ली",
      heroTitleA: "गुर्जन, यूकेलिप्टस व ओकूमे।",
      heroTitleB: "वीनियर, सीधा इम्पोर्टेड।",
      heroSub: "प्लाईवुड, दरवाज़ों और फर्नीचर के लिए प्रीमियम गुर्जन फेस वीनियर तथा यूकेलिप्टस / ओकूमे कोर वीनियर — म्यांमार, दक्षिण-पूर्व एशिया और अफ्रीकी मिलों से सीधे आपकी फैक्ट्री तक।",
      viewProducts: "प्रोडक्ट देखें",
      whatsapp: "व्हाट्सऐप करें",
      contactEyebrow: "संपर्क",
      contactTitle: "बात करें",
    },
    products: {
      eyebrow: "हमारे प्रोडक्ट",
      title: "तीन वीनियर। एक ही मानक।",
      enquire: "पूछताछ करें",
      labels: { thickness: "थिकनेस", sizes: "साइज़", type: "ग्रेड / प्रकार", use: "उपयोग" },
      items: [
        { id: "gurjan", name: "गुर्जन फेस वीनियर", tag: "प्लाईवुड व दरवाज़ों का प्रीमियम फेस", thickness: "0.35 / 0.45 / 0.55 / 0.60 मिमी", sizes: "8×4 फीट · 7×4 फीट", type: "ग्रेड A · B · C · D", use: "डेकोरेटिव फेस — प्लाईवुड, दरवाज़े, पैनल" },
        { id: "eucalyptus", name: "यूकेलिप्टस कोर वीनियर", tag: "मज़बूत, एकसमान प्लांटेशन कोर", thickness: "1.5 / 1.7 / 1.8 / 2.2 मिमी", sizes: "8×4 फीट", type: "प्लांटेशन कोर ग्रेड", use: "कोर लेयर — प्लाईवुड व ब्लॉकबोर्ड" },
        { id: "okume", name: "ओकूमे कोर वीनियर", tag: "हल्का अफ्रीकी कोर, स्मूद फिनिश", thickness: "1.5 – 2.5 मिमी", sizes: "8×4 फीट", type: "इम्पोर्टेड कोर (गैबॉन)", use: "हल्की प्लाईवुड, फ्लश डोर, पैनल" },
      ],
    },
    reg: {
      eyebrow: "पंजीकृत कार्यालय व विवरण",
      title: "आरव्य इम्पेक्स प्राइवेट लिमिटेड",
      motto: "गुणवत्ता · विश्वास · विकास",
      addressLabel: "पंजीकृत पता",
      address: "सी-50, राजपुर खुर्द एक्सटेंशन, छत्तरपुर, नई दिल्ली – 110068",
      items: [
        { k: "GSTIN", v: "07ABFCA0324G1Z6" },
        { k: "PAN", v: "ABFCA0324G" },
        { k: "IEC", v: "ABFCA0324G" },
        { k: "UDYAM", v: "UDYAM-DL-08-0120430" },
        { k: "CIN", v: "U16211DL2026PTC464017" },
      ],
    },
    form: {
      eyebrow: "अपनी ज़रूरत भेजें",
      titleA: "बताइए आपको क्या",
      titleItalic: "चाहिए।",
      intro: "प्रोडक्ट, थिकनेस, मात्रा — अपनी ज़रूरत भेजें, हम एक कार्यदिवस के भीतर मौजूदा स्टॉक और लैंडेड कोट के साथ जवाब देंगे।",
      name: "आपका नाम *",
      company: "कंपनी / फर्म",
      phone: "फ़ोन / व्हाट्सऐप *",
      email: "ईमेल",
      product: "प्रोडक्ट",
      productOptions: ["गुर्जन फेस वीनियर", "यूकेलिप्टस कोर वीनियर", "ओकूमे कोर वीनियर"],
      grade: "चाहिए ग्रेड",
      thickness: "थिकनेस",
      quantity: "मासिक मात्रा (शीटें)",
      message: "संदेश — डिलीवरी शहर, समय, अन्य जानकारी",
      submit: "पूछताछ भेजें",
      submitting: "भेजा जा रहा है…",
      notSure: "पक्का नहीं — सलाह दें",
      success: "पूछताछ भेज दी गई — एक कार्यदिवस में जवाब मिलेगा",
      error: "अभी भेजा नहीं जा सका। कृपया व्हाट्सऐप या ईमेल से संपर्क करें।",
      required: "कृपया नाम और फ़ोन भरें",
      gradeOptions: ["ग्रेड A — सॉवरिन", "ग्रेड B — प्रीमियर", "ग्रेड C — मर्चेंट", "ग्रेड D — कोरलाइन"],
      thicknessOptions: ["0.35 mm", "0.45 mm", "0.55 mm", "0.60 mm"],
    },
    contact: {
      eyebrow: "पूछताछ",
      titleA: "आइए बात करें",
      titleItalic: "टिम्बर की।",
      body: "मिलें, प्लाईवुड हाउस, फर्नीचर निर्माता और ट्रेडर — मौजूदा लॉट, लैंडेड प्राइसिंग और स्पेक शीट के लिए सीधे हमारे प्रिंसिपल को लिखें।",
      principalLabel: "प्रिंसिपल संपर्क",
      person: "उमा शंकर",
      phoneLabel: "फ़ोन / व्हाट्सऐप",
      corridorsLabel: "पता",
      corridorsValue: "सी-50, राजपुर खुर्द एक्सटेंशन, छत्तरपुर, नई दिल्ली – 110068",
      responseLabel: "जवाब का समय",
      responseValue: "एक कार्यदिवस के भीतर जवाब",
      cardLabel: "डायरेक्ट लाइन",
      cardText: "अपना ग्रेड, कैलिबर और मासिक ज़रूरत बताएं — हम मौजूदा स्टॉक और लैंडेड कोट के साथ जवाब देंगे।",
      mailto: "उमा शंकर को लिखें",
      copy: "ईमेल कॉपी करें",
      copied: "कॉपी हो गया",
      toastSuccess: "ईमेल पता कॉपी हो गया",
      toastError: "कॉपी नहीं हो सका — कृपया पता चुनकर कॉपी करें",
    },
    footer: {
      tagline: "गुर्जन · यूकेलिप्टस · ओकूमे वीनियर — डायरेक्ट इम्पोर्ट",
      rights: "आरव्य इम्पेक्स प्राइवेट लिमिटेड",
      links: { products: "प्रोडक्ट", enquiry: "पूछताछ", contact: "संपर्क" },
    },
    whatsapp: {
      label: "व्हाट्सऐप पर चैट करें",
      message: "नमस्ते आरव्य इम्पेक्स, मुझे वीनियर के बारे में जानकारी चाहिए।",
    },
  },
};

export const CONTACT = {
  person: "Uma Shanker",
  email: "Aaravyaimpex@gmail.com",
  phoneDisplay: "+91 99999 88439",
  phoneRaw: "+919999988439",
  whatsapp: "919999988439",
  specSheet: "/aaravya-gurjan-spec-sheet.pdf",
  specSheetHi: "/aaravya-gurjan-spec-sheet-hi.pdf",
  address: "C-50, Rajpur Khurd Extension, Chhatarpur, New Delhi – 110068",
};
